import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import Swal from 'sweetalert2'
export const baseUrl = "https://api.easycard724.com/api"
const header = { 'Content-Type': 'application/json; charset=utf-8' }
const getAuthHeader = () => {
    try {
        let token = localStorage.getItem('user_info');
        if (token) {
            token = JSON.parse(token)
            token = token.accessToken;
        }
        else{
            window.location.replace('/pages/login')
        }
        return { 'Authorization': 'Bearer ' + token };
    } catch (error) {

    }
}
const api = async (method, url, params = {}, additionalHeaders = null) => {
    // additionalHeaders:{ preventShowError : boolean };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json; charset=utf-8");
    // myHeaders.append("Cookie", "JSESSIONID=node072dec6r1f87vg7gwqo6l9urd298.node0");

    if (method == "get") {
        // url += "?";
        // var paramsObj = Object.keys(params).map((key) => [(key), params[key]]);
        // paramsObj.forEach((element, index) => {
        //     url += `${index}=!${element}&`;
        // });
        // let raw = JSON.stringify(params);
        // let requestOptions = {
        //     method: 'GET',
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: 'follow'
        // };
        // return await fetch(`${baseUrl}${url}`, requestOptions);

        var data = JSON.stringify(params);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${baseUrl}${url}`,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                //   'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };
        axios.defaults.withCredentials = true;
        return new Promise(async (resolve, reject) => {

            let result = null;
            let response = await axios(config).then(res => {
                result = res;
            }).catch(error => {
                if (error.response.status === 401) {
                    // window.location.replace('/pages/login');
                }
                else {
                    result = error.response;
                    if (!additionalHeaders || additionalHeaders.preventShowError !== true) {
                        // store.dispatch({ type: "SET_ERRORS", payload: { errors: [error.response.data] } });
                    }
                }
                reject(error);
            })
            resolve(result);
        });
    }
    if (method == "post") {
        // let raw = JSON.stringify(params);
        // let requestOptions = {
        //     method: 'POST',
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: 'follow'
        // };        
        // return await fetch(`${baseUrl}${url}`, requestOptions);

        var data = JSON.stringify(params);

        var config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}${url}`,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                //   'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };
        axios.defaults.withCredentials = true;
        return new Promise(async (resolve, reject) => {

            let result = null;
            let response = await axios(config).then(res => {
                result = res;
            }).catch(error => {
                if (error.response.status === 401) {
                    Swal.fire({
                        icon: "warning",
                        title: "لطفا دوبار تلاش نمایید",
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
                else {
                    result = error.response;
                    if (!additionalHeaders || additionalHeaders.preventShowError !== true) {
                        // store.dispatch({ type: "SET_ERRORS", payload: { errors: [error.response.data] } });
                    }
                }
                reject(error);
            })
            resolve(result);
        });
    }
    // if you need to pass some params in url (post method) use 
    // method = "postQuery" and your params should be like this : 
    // params = {query : { ... : ...} , raw : { ... : ...}}
    if (method == "postQuery") {
        url += "?";
        var paramsObj = Object.keys(params.query).map((key) => [(key), params.query[key]]);
        paramsObj.forEach((element, index) => {
            url += `${element[0]}=${element[1]}&`;
        });
        // return await axios.post(url, params.raw, { headers: { ...defaultHeaders() } });
        let raw = JSON.stringify(params);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        return await fetch(`${baseUrl}${url}`, requestOptions);
    }
};

// services

// login
export const GetGiftCardCategories = async (params) => {
    return api("get", "/Category/GetGiftCardCategories", params);
}
export const GetGiftCardProducts = async (params) => {
    return api("get", `/Category/GetGiftCardProducts/${params.id}`);
}
export const GetGiftCardCategory = async (params) => {
    return api("get", `/Category/GetGiftCardCategory/${params}`);
}

// Payment
export const RequestGiftCardPayment = async (params) => {
    return api("post", `/Payment/RequestGiftCardPayment`, params);
}
export const GetPaymentData = async (params) => {
    return api("get", `/Payment/GetPaymentData/${params.token}`);
}
export const ConfirmOrder = async (params) => {
    return api("post", `/Payment/ConfirmOrder/${params.token}/${params.variant}`, {});
}

// Orders
export const GetGiftCardOrders = async (params) => {
    return api("post", `/Order/GetGiftCardOrders`, params);
}
export const GetGiftCardSerials = async (params) => {
    return api("get", `/Order/GetGiftCardSerials/${params}`);
}


// validationCode
export const GetToken = async (params) => {
    return api("get", `/Token/GetToken/${params}`);
}

//customer
export const GetCustomer = async (params) => {
    return api("get", `/Customer/GetCustomer/${params}`);
}

export const changePasswordApi = async (params) => {
    await axios.post(`${baseUrl}/Customer/ChangePassword`, params, { headers: { ...header, ...getAuthHeader() }, withCredentials: false }).then(res => {
        if (res.data.operationMessageCode == 200) {
            Swal.fire({
                icon: "success",
                title: " تغییر رمز عبور با موفقیت انجام شد",
                showConfirmButton: false,
                timer: 1500
            })
        }
    }).catch(error => {
        Swal.fire({
            title: '!خطا',
            text: error.response.data.operationMessage,
            icon: 'error',
            confirmButtonText: 'تایید'
        })
    })
}
export const updateCustomer = async (params) => {
    await axios.put(`${baseUrl}/Customer/UpdateCustomer`, params, { headers: { ...header, ...getAuthHeader() }, withCredentials: false }).then(res => {
        if (res.data.operationMessageCode == 200) {
            Swal.fire({
                icon: "success",
                title: "ویرایش کاربر با موفقیت انجام شد",
                showConfirmButton: false,
                timer: 1500
            })
        }
    }).catch(error => {
        Swal.fire({
            title: '!خطا',
            text: error.response.data.operationMessage,
            icon: 'error',
            confirmButtonText: 'تایید'
        })
    })
}

// Category
export const LoginApi = async (params, callBackUrl = null) => {
    await axios.post(`${baseUrl}/Customer/Login`, params, { headers: header, withCredentials: false }).then(res => {
        if (res.data.operationMessageCode == 200) {
            localStorage.setItem("token", res.data.response.accessToken)
            localStorage.setItem("user_info", JSON.stringify(res.data.response))
            // Swal.fire({
            //     icon: "success",
            //     title: "ورود موفق",
            //     showConfirmButton: false,
            //     timer: 1500
            // })
            if (!callBackUrl) {
                window.location.replace('/');
            }
            else {
                window.location.replace(callBackUrl);
            }
        }
    }).catch(error => {
        if (error && error.response) {
            Swal.fire({
                title: '!خطا',
                text: error.response.data.operationMessage,
                icon: 'error',
                confirmButtonText: 'تایید'
            })
        }
        else {
            Swal.fire({
                title: '!خطا',
                text: JSON.stringify(error),
                icon: 'error',
                confirmButtonText: 'تایید'
            })
        }
    })
}

// register
export const CustomerRegister = async (params, callBackUrl = null) => {
    await axios.post(`${baseUrl}/Customer/AddCustomer`, params, { headers: header, withCredentials: false }).then(res => {
        if (res.data.operationMessageCode == 200) {
            Swal.fire({
                icon: "success",
                title: "کاربر با موفقیت ثبت شد",
                showConfirmButton: false,
                timer: 1500
            }).then((result) => {
                LoginApi({
                    username: params.Username,
                    password: params.Password,
                }, callBackUrl);
            });
        }
    }).catch(error => {
        Swal.fire({
            title: '!خطا',
            text: error.response.data.operationMessage,
            icon: 'error',
            confirmButtonText: 'تایید'
        })
    })
}

export const TokenValidation = async (params) => {
    let result = ''
    await axios.post(`${baseUrl}/Token/TokenValidation`, params, { headers: header, withCredentials: false }).then(res => {
        if (res.data.operationMessageCode === 200) {
            result = res.data.operationMessageCode
        }
    }).catch(error => {
        Swal.fire({
            title: '!خطا',
            text: error.response.data.operationMessage,
            icon: 'error',
            confirmButtonText: 'تایید'
        })
    })
    return result
}
